const config= {
    apiName: 'Impressions',
    basePath: '/',
    thumbnailLambdaUrl: 'https://kpg6drp5w4lzvezfq2otvfpt4i0ryliv.lambda-url.us-east-1.on.aws',
    freeUsageSize: 50000
}
export default config;
